import modules from './dynamicRouter'

export function generateRoutes(menuList){

  let routes = [];
  menuList.forEach(item => {

    if(item.type === 'menu' && item.path){

      const component =
        modules[item.path];

  /*    console.log(
        "菜单:",
        item.path,
        "组件:",
        component
      );*/

      if(component){

    /*    routes.push({
          path:item.path,
          name:item.id,
          meta:{
            title:item.names['zh-CN']
          },
          component

        });*/
        routes.push({
          path:item.path,
          name:item.id,
          perms:item.perms,
          meta:{
            names:item.names
          },
          component
        });

      }

    }

    if(item.children){

      routes.push(
        ...generateRoutes(item.children)
      );

    }

  });

  return routes;

}



// WEBPACK FOOTER //
// ./src/router/permission.js